import {injectIntl} from "react-intl"
import React from "react"

export default injectIntl(
  class DocumentTitle extends React.Component {
    componentWillMount() {
      document.title = this.props.intl.formatMessage({
        id: "view.document.title",
      })
    }
    render() {
      return null
    }
  },
)



// WEBPACK FOOTER //
// ./src/app/DocumentTitle.js